<template lang="html">

  <div class="escucha-aldonza">

    <section class="full-view-intro column-center banner-intro
    animation" data="escucha-aldonza">

            <video controls="false" loop="true" muted="true" id="video-ondas" autoplay="true" playsinline>
    <source src="/static/video/video-ondas.mp4" type="video/mp4">
    </video>


    <h1 class="title -intro">{{$t('vistas.escucha_aldonza')}}</h1>

    <h2 class="subtitle-intro">{{$t('vistas.experiencias')}}</h2>

  </section>

  <section class="intro-experiencias">
    <article class="claim container  animation">
      <h2 class="title">{{$t('escucha.intro')}}</h2>
    </article>

    <div class="contenedor-info container animation">

      <h2 class="title">{{$t('escucha.cuerpo_intro')}}</h2>

      <div class="experiencias-list row-center ais animation">
        <article class="experiencia-el">
          <span><img src="/static/img/icon-portatil.svg"></span>
          <p>{{$t('escucha.tip_volumen')}}</p>
        </article>
        <article class="experiencia-el">
          <span><img src="/static/img/icon-cascos.svg"></span>
          <p>{{$t('escucha.tip_cascos')}}</p>
        </article>
        <article class="experiencia-el">
          <span><img src="/static/img/icon-playlist.svg" width="50"></span>
          <p>{{$t('escucha.tip_dados')}}</p>
        </article>
      </div>

    </div>
  </section>


  <section class="escucha-wrapper row-center">


    <div class="container row-end">
      
      <div class="contenedor-texto column-start">
        <img src="/static/img/logo-spotify.png" alt="Logo spotify" class="logo-spotify" width="155">
        <h2 class="title">{{$t('escucha.spotify.titulo')}}</h2>
        <p>{{$t('escucha.spotify.cuerpo')}}</p>
        <a class="btn" target="_blank" href="https://open.spotify.com/user/fx3dz4opemgwlz0znh3q0ofj9/playlist/5ZDzgDaoln0r1YzCc8MlQw">
          <span>{{$t('escucha.spotify.boton')}}</span>
        </a>
      </div>

    </div>

    
  </section>

  <section class="banners-social row-center ais">

    <article class="rrss-share column-center">
      <div class="container -xxs">
        <h2 class="title" v-html="$t('escucha.comparte.titulo')"></h2>
        <p v-html="$t('escucha.comparte.cuerpo')"></p>
        <nav class="rrss row-center">
          <a :href="'http://www.facebook.com/sharer.php?u='+url+'&t=Escucha la experiencia Aldonza'" target="_blank"><i class="fa fa-facebook"></i></a>
          <a :href="'http://twitter.com/intent/tweet?text=Escucha la experiencia Aldonza&url='+url" target="_blank"><i class="fa-brands fa-x-twitter"></i></i></a>
          <a :href="'https://www.linkedin.com/shareArticle?mini=false&url='+url"  target="_blank"><i class="fa fa-linkedin"></i></a>
        </nav>
      </div>
    </article>

  </section>

  <div class="contenedor-blog animation">

    <blog></blog>

  </div>

  <div class="otras-experiencias animation">

    <div class="contenedor-experiencia vive-aldonza">

      <article 
      class="banner-vive-aldonza column-center container">
      <h2 class="title -ghost">{{$t('otras_experiencias.titulo')}}</h2>
      <router-link :to="$t('enlaces.vive_aldonza')" class="enlace-cover" ></router-link>
      <router-link :to="$t('enlaces.vive_aldonza')" class="btn">
        <span>{{$t('vistas.vive_aldonza')}}</span>
      </router-link>
    </article>

  </div>

</div>


</div>

</template>

<script lang="js">

  require('waypoints/lib/noframework.waypoints.js')

  import blog from '@/components/parts/blog';

  export default  {
    name: 'escucha-aldonza',
    components : {
      'blog' : blog
    },
    mounted(){
      this.waypoints();
    },
    methods :{
      waypoints : function() {

        var waypoints = document.getElementsByClassName('animation');

        for (var i = 0; i < waypoints.length; i++) {
          new Waypoint({
            element: waypoints[i],
            offset : '80%',
            handler: function() {
              this.element.classList.add("launched")  
            }
          });
        }

      }
    },
    computed : {
      url : function(){
        return window.location.href;
      }
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .escucha-aldonza {

  }

  .full-view-intro[data="escucha-aldonza"]{
    /*background: url("/static/img/escucha-aldonza/background-intro-escucha-aldonza.jpg") center/cover no-repeat;*/
  }

  #video-ondas{
    position: absolute;
    left: 50%;
    top: 50%;
    min-height: 100vh;
    min-width: 100vw;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

  .intro-experiencias{
    width: 100%;
    background: $mud-brown;
    padding-bottom: 0;

    .claim{
      background: $plum;
    }

    .contenedor-info{
      > .title{
        max-width: 640px;
      }
    }

  }

  .escucha-wrapper{
    background: $plum;
    padding: 50px 0 0 0;

    .title{
      margin-bottom: 0;
      padding-bottom: 0;
      transform: translateY(-12px);

    }
  }

  .contenedor-texto{
    background: none;
    img{
      margin-bottom: 30px;
    }
    p{
      margin-bottom: 30px;
    }
  }

  .escucha-el{
    width: 50vw;
    height: 25vw;
    -webkit-flex-wrap: nowrap;
    -moz-flex-wrap: nowrap;
    -ms-flex-wrap: nowrap;
    -o-flex-wrap: nowrap;
    flex-wrap: nowrap;
    position: relative;

    .contenedor-imagen{
      width: 25vw;
      height: 25vw;
      background: red;
      display: inline-block;
    }

    &[reverse=true] .contenedor-imagen{
      order: -1;
    }

    .boton-escuchar{
      width: 25vw;
      height: 25vw;
      background: url("/static/img/banner-escucha-aldonza.png") center/cover no-repeat;
      position: relative;
    }

    .boton-escuchar::before{
      position: absolute;
      left: 50%;
      top: 50%;
      width: 14vw;
      height: 14vw;
      margin-left: -7vw;
      margin-top: -7vw;
      background: $mud-brown;
      display: inline-block;
      content: '';
      border-radius: 50%;
    }

    &:hover .boton-escuchar::before{
      animation-name: breath;
      animation-duration: 5s;
      animation-iteration-count: infinite;
    }

    .btn{
      min-width: 16vw;
    }

  }

  .contenedor-blog{
    padding-top: 100px;
  }

  @keyframes breath{
    from {
      transform: scale(1);
    }

    50%{
      transform: scale(1.2); 
    }

    to{
     transform: scale(1); 
   }
 }

 .escucha-wrapper{
  width: 100%;
  height: 100vh;
  padding: 50px;
  background: url(/static/img/escucha-aldonza/background-spotify.jpg) center/cover no-repeat;
 }

 .banners-social{
  width: 100%;

  > article{
    width: 50%;
    padding: 50px;
    min-height: 500px;
  }

  .spotify{
    background: $plum;
    position: relative;

    .contenedor-logo{
      margin-bottom: 20px;
    }

    .btn{
      margin-top: 40px;
      z-index: 6;
      position: relative;
    }
  }

  .rrss-share{
    background: $mud-brown;
    width: 100%;

    .title{
      text-align: center;
      &::before{
        left:50%;
        transform: translateX(-50%);
      }
    }

    p{
      text-align: center;
    }

    .rrss a{
      width: 25px;
      height: 25px;
      margin: 0 5px;
      line-height: 25px;
      border-radius: 50%;
      border: 1px solid white;
      font-size: 14px;
      text-align: center;
      transform: translateY(150%);
      transition: .3s;
    }
  }
}

@media screen and (max-width: 900px){

  .intro-experiencias .experiencia-el{
    width: 50%;
    &:nth-child(1){
      padding-right: 20px;
    }
    &:nth-child(2){
      width: 100%;
      order: -1;
    }
    &:nth-child(3){
      padding-left: 20px;
    }
  }

  .escucha-el{
    width: 100%;
    height: 50vw;

    .boton-escuchar,.contenedor-imagen{
      width: 50%;
      height: 50vw;
    }

    &[reverse=true] .contenedor-imagen{
      order: 0;
    }

    &:nth-child(2n) .contenedor-imagen{
      -webkit-order: -1;
      -moz-order: -1;
      -ms-order: -1;
      -o-order: -1;
      order: -1;
    }

    .boton-escuchar::before{

      width: 25vw;
      height: 25vw;
      margin-left: -12.5vw;
      margin-top: -12.5vw;
    }

    .boton-escuchar::before{
      animation-name: breath;
      animation-duration: 5s;
      animation-iteration-count: infinite;
    }

    @for $i from 1 through 10{
      &:nth-child(#{$i}) .boton-escuchar::before{
        animation-duration:#{(random(10) + 3)}s;
      }
    }
  }

  .banners-social{
    > article{
      width: 100%;
      padding: 50px 0px;
      min-height: 300px;
    }
    .rrss-share{
      padding-bottom: 75px;
    }
  }
}

@media screen and (max-width: 700px){
  .intro-experiencias .contenedor-info{
    padding: 0;
  }
  .intro-experiencias .experiencia-el{
    width: 100%;
    margin-bottom: 20px;
    padding: 0;
    &:nth-child(1){
      padding-right: 0;
    }

    &:nth-child(3){
      padding-left: 0;
    }
  }
  .contenedor-blog{
    padding-top: 50px;
  }
  .escucha-wrapper .title{
    transform: translateY(7px);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/experiencias/escucha-aldonza.vue